var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorBall",staticStyle:{"height":"1em","width":"1em","margin-right":"3px","margin-top":"-5px","cursor":"pointer"},style:({ background: _vm.color || '#FFFFFF' })})}
var staticRenderFns = []

export { render, staticRenderFns }